(function () {
  'use strict';

  if (window.JMTOrderAttribution) return;

  var ATTRIBUTE_NAME = 'JMT';
  var SESSION_KEY = 'jmt:order-attribution';
  var LEGACY_ATTRIBUTES = [
    '__jmt_first_customer_page',
    '__jmt_first_customer_source',
    '__jmt_first_customer_visit'
  ];
  var updateQueue = Promise.resolve();

  function routesRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function cleanCode(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9_-]/g, '')
      .slice(0, 12);
  }

  function cleanValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9_-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 32);
  }

  function parse(value) {
    var tokens = {};
    String(value || '').split('|').forEach(function (token) {
      var separator = token.indexOf(':');
      if (separator < 1) return;
      var code = cleanCode(token.slice(0, separator));
      var tokenValue = cleanValue(token.slice(separator + 1));
      if (code && tokenValue) tokens[code] = tokenValue;
    });
    return tokens;
  }

  function serialize(tokens) {
    var preferredOrder = ['NC', 'TOW'];
    var keys = Object.keys(tokens).filter(function (key) {
      return cleanCode(key) && cleanValue(tokens[key]);
    });
    keys.sort(function (left, right) {
      var leftIndex = preferredOrder.indexOf(left);
      var rightIndex = preferredOrder.indexOf(right);
      if (leftIndex === -1) leftIndex = preferredOrder.length;
      if (rightIndex === -1) rightIndex = preferredOrder.length;
      return leftIndex === rightIndex ? left.localeCompare(right) : leftIndex - rightIndex;
    });
    return keys.map(function (key) {
      return cleanCode(key) + ':' + cleanValue(tokens[key]);
    }).join('|').slice(0, 120);
  }

  function mergeTokens(primary, fallback) {
    return Object.assign({}, parse(fallback), parse(primary));
  }

  function readCart() {
    return fetch(routesRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart attribution');
      return response.json();
    });
  }

  function writeCart(value, options) {
    var attributes = {};
    attributes[ATTRIBUTE_NAME] = value;
    if (options && options.clearLegacy) {
      LEGACY_ATTRIBUTES.forEach(function (key) {
        attributes[key] = '';
      });
    }

    return fetch(routesRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to save cart attribution');
      return response.json();
    });
  }

  function update(code, value, options) {
    var safeCode = cleanCode(code);
    var safeValue = cleanValue(value);
    if (!safeCode) return Promise.resolve('');

    return readCart()
      .catch(function () {
        return { attributes: {} };
      })
      .then(function (cart) {
        var cartValue = cart && cart.attributes ? cart.attributes[ATTRIBUTE_NAME] : '';
        var tokens = mergeTokens(cartValue, storageGet(SESSION_KEY));
        if (safeValue) tokens[safeCode] = safeValue;
        else delete tokens[safeCode];

        var nextValue = serialize(tokens);
        return writeCart(nextValue, options).then(function () {
          storageSet(SESSION_KEY, nextValue);
          return nextValue;
        });
      });
  }

  window.JMTOrderAttribution = {
    attributeName: ATTRIBUTE_NAME,
    set: function (code, value, options) {
      updateQueue = updateQueue
        .catch(function () {})
        .then(function () {
          return update(code, value, options || {});
        });
      return updateQueue;
    }
  };
})();
